module.exports = __webpack_public_path__ + "static/media/dcbgnew.3f7eb88b.webp";